import { Tag } from "@chakra-ui/react";
import { ProcuracaoItem } from "core/features/assembleia/typings/procuracao";
import { useMemo } from "react";
import { getTagColorSchemeForStatus, getTagVariantForStatus } from "../util";

function useListagemProcuracoesColumns() {
  return useMemo(() => {
    return [
      {
        title: "Nome do morador",
        render: (original: ProcuracaoItem) => (
          <div>{original.solicitante.nome}</div>
        ),
      },
      {
        title: "Nome do representante",
        render: (original: ProcuracaoItem) => (
          <div>{original.representante.nome}</div>
        ),
      },
      {
        title: "Status",
        onClick: () => {},
        render: (original: ProcuracaoItem) => (
          <div>
            <Tag
              h="30px"
              w="100px"
              display="flex"
              justifyContent="center"
              colorScheme={getTagColorSchemeForStatus(original.status.id)}
              variant={getTagVariantForStatus(original.status.id)}
              rounded="full"
              textAlign="center"
            >
              {original.status.nome}
            </Tag>
          </div>
        ),
      },
    ];
  }, []);
}

export default useListagemProcuracoesColumns;
